/* Text for searching: accent folding, and a message reduced to the words a
 * reader might look for. Shared by the worker (message text) and the page
 * (the header index), so both sides fold the same way.
 */

/**
 * Lower case with accents removed: "cafe" finds "café" and "καλημερα" finds
 * "Καλημέρα". People rarely type accents into a search box.
 */
export function fold(text) {
  return text.normalize("NFD").replace(/\p{M}+/gu, "").toLowerCase();
}

/** HTML to its words, for searching only; never for display. */
export function htmlToPlain(html) {
  return html
    .replace(/<(style|script|head)[\s\S]*?<\/\1>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'")
    .replace(/\s+/g, " ");
}

/**
 * Everything searchable about a parsed message, folded. **Headers go in too**,
 * so a query with one word in the sender and another in the body matches.
 */
export function searchableText(parsed) {
  const people = [parsed.from, ...(parsed.to || []), ...(parsed.cc || [])]
    .filter(Boolean)
    .map((person) => `${person.name || ""} ${person.address || ""}`)
    .join(" ");

  const names = (parsed.attachments || []).map((a) => a.filename).filter(Boolean).join(" ");

  return fold([parsed.subject || "", people, parsed.text || htmlToPlain(parsed.html || ""), names].join(" "));
}

/** Every term appears somewhere in the text. */
export function matchesAll(text, terms) {
  for (const term of terms) {
    if (!text.includes(term)) return false;
  }
  return true;
}
